import { render } from "./MidGridFeaturedCollection.vue?vue&type=template&id=6bff5934&scoped=true"
import script from "./MidGridFeaturedCollection.vue?vue&type=script&lang=js"
export * from "./MidGridFeaturedCollection.vue?vue&type=script&lang=js"

import "./MidGridFeaturedCollection.vue?vue&type=style&index=0&id=6bff5934&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bff5934"]])

export default __exports__